import React from "react";
import styled from "styled-components";
import LSRgCaption03 from "./../../molecules/text/linSeedKr/Rg/lsRgCaption03";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import LSRgCaption02 from "../../molecules/text/linSeedKr/Rg/lsRgCaption02";

const InputField = ({
  isSmall,
  id,
  name,
  autoComplete,
  value,
  style,
  containerStyle,
  type,
  placeholder,
  readOnly,
  disabled,
  required,
  onChange,
  onKeyDown,
  isGuide,
  guideMsg,
  isWarring,
  warringMsg,
  isShowBtn,
  btnText,
  btnHandler,
  maxLength,
}) => {
  return (
    <InputFieldContainer
      disabled={disabled}
      style={{
        ...containerStyle,
      }}
    >
      <InputFieldWrapper disabled={disabled} isSmall={isSmall}>
        <StyledInputField
          style={{
            ...style,
          }}
          isSmall={isSmall}
          isShowBtn={isShowBtn}
          type={type || "text"}
          id={id}
          name={name}
          autoComplete={autoComplete}
          value={value}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          onChange={onChange}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
        ></StyledInputField>
        {isShowBtn && (
          <InputBtn
            onClick={() => {
              btnHandler();
            }}
          >
            <LSRgBody01 style={{ color: "#fff" }}>{btnText}</LSRgBody01>
          </InputBtn>
        )}
      </InputFieldWrapper>
      {isGuide && (
        <GuideWrapper>
          <GuideIcon src="/assets/icons/warring.png" alt="주의사항" />
          {isSmall && (
            <LSRgCaption02 style={{ color: "#A4A8B1" }}>
              {guideMsg || ""}
            </LSRgCaption02>
          )}

          {!isSmall && (
            <LSRgCaption03
              style={{
                color: "#A4A8B1",
              }}
            >
              {guideMsg || ""}
            </LSRgCaption03>
          )}
        </GuideWrapper>
      )}

      {isWarring && (
        <GuideWrapper>
          <GuideIcon src="/assets/icons/warning_r.png" alt="주의사항" />
          {isSmall && (
            <LSRgCaption02 style={{ color: "#F24147" }}>
              {warringMsg || ""}
            </LSRgCaption02>
          )}

          {!isSmall && (
            <LSRgCaption03
              style={{
                color: "#F24147",
              }}
            >
              {warringMsg || ""}
            </LSRgCaption03>
          )}
        </GuideWrapper>
      )}
    </InputFieldContainer>
  );
};

export default InputField;

const InputFieldContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${(props) => (props.disabled ? "#f6f7f8" : "#fff")};
  border-radius: 12px;
`;

const InputFieldWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  height: fit-content;
  width: 100%;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid #dbdde0;
  background-color: ${(props) => (props.disabled ? "#f6f7f8" : "transparent")};
`;

const StyledInputField = styled.input.attrs((props) => {})`
  margin: ${(props) =>
    props.isShowBtn && !props.isSmall
      ? "17px 0px 17px 15px"
      : !props.isShowBtn && props.isSmall
      ? "12px 15px"
      : "17px 15px"};
  width: ${(props) =>
    props.isShowBtn && !props.isSmall
      ? "586px"
      : props.isShowBtn && props.isSmall
      ? "230px"
      : "100%"};
  border: none;

  font-family: "LINESeedKR-Rg";
  color: #000000;
  font-weight: 400;
  font-size: ${(props) => (props.isSmall ? "14px" : "16px")};
  line-height: ${(props) => (props.isSmall ? "140%" : "24px")};
  letter-spacing: -0.3px;

  &::placeholder {
    color: #a4a8b1;
  }

  &:disabled {
    background-color: #f6f7f8;
  }

  &:focus {
    outline: none;
  }
`;

const InputBtn = styled.button.attrs((props) => {})`
  width: 65px;
  height: 32px;
  background-color: #101113;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
`;

const GuideWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 3px;
  align-items: center;
  height: fit-content;
  width: fit-content;
`;

const GuideIcon = styled.img.attrs((props) => {})`
  width: 14px;
  height: 14px;
  object-fit: cover;
`;
